import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { ToasterTypes } from 'src/app/core/enum/toaster-type.enum';
import { AuthService } from 'src/app/core/service/auth/auth.service';
import { NotificationsHubService } from 'src/app/core/service/hubs/notifications-hub.service';
import { SuppliersService } from 'src/app/data/service/suppliers.service';
import { UserService } from 'src/app/data/service/user.service';
import { ToasterMessageService } from 'src/app/shared/toaster-message/toaster-message.service';
import { RefreshLog_Type } from '../../../../data/enums/common-enum';
import mixpanel from "mixpanel-browser";
import { ManageIntercom } from 'src/app/core/util/manage-intercom';
import { AppConfigService } from 'src/app/appConfig.service';

@Component({
  selector: 'app-xero-sign-up',
  templateUrl: './xero-sign-up.component.html',
  styleUrls: ['./xero-sign-up.component.scss']
})
export class XeroSignUpComponent implements OnInit, OnDestroy {
  xeroSignUpData: any = null;
  reveivedData: any = null;
  isSpinnerShown: boolean = true;
  redirectionText: string = 'Redirecting to Xero...';
  redirectionSubText: string = null;

  private _unsubscribe$ = new Subject<void>();

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly _authService: AuthService,
    private readonly _toasterMessageService: ToasterMessageService,
    private readonly _userService: UserService,
    private readonly suppliersService: SuppliersService,
    private readonly router: Router,
    private readonly _notificationsHubService: NotificationsHubService,
    private readonly configService: AppConfigService
  ) { }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(params => {
        let data = params['data'];
        let error = params['error'];

        if (data && data != '') {
          this.redirectionText = 'Signing Up to Synced...';
          this.reveivedData = JSON.parse(data);
          this.xeroSignUpData = this.reveivedData?.Data;

          this._authService.accessUpUserId = this.xeroSignUpData?.user?.Id;

          sessionStorage.UserName = this.xeroSignUpData?.user?.Name;
          sessionStorage.Id = this.xeroSignUpData?.user?.Id;
          sessionStorage.UserId = this.xeroSignUpData?.user?.UserId;
          localStorage.setItem('UserName', this.xeroSignUpData?.user?.Name);
          localStorage.setItem('UserId', this.xeroSignUpData?.user?.UserId);
          localStorage.setItem('Id', this.xeroSignUpData?.user?.Id);
          localStorage.setItem('SelectedOrganization', this.xeroSignUpData?.user?.OrganizationId);
          localStorage.setItem('IsLogedin', 'true');
          localStorage.setItem('IsXeroDirect', 'true');
          localStorage.setItem("roleId", this.xeroSignUpData?.user?.Role);
          const user = {
            email: this.xeroSignUpData?.user?.Email,
            id: this.xeroSignUpData?.user?.Id,
            name: this.xeroSignUpData?.user?.Name,
            firstname: this.xeroSignUpData?.user?.FirstName,
            lastname: this.xeroSignUpData?.user?.LastName,
            organizationId: this.xeroSignUpData?.user?.OrganizationId,
            role: this.xeroSignUpData?.user?.Role,
            userId: this.xeroSignUpData?.user?.UserId
          } as any;

          localStorage.setItem('Email', this.xeroSignUpData?.user?.Email);
          if (this.xeroSignUpData?.user?.CreatedDate) {
            localStorage.setItem('CreatedAt', this.xeroSignUpData?.user?.CreatedDate);
          }

          this.initializeAndIdentifyMixpanelUser();
          this._userService.upUserDetails = JSON.stringify(user);
          this._userService.setUserRoleData(user.role);
          this._toasterMessageService.displayToasterState(ToasterTypes.Success, 'Congrats!', 'You were just signed up in Synced');
          this.setonBoardingStatus(this.xeroSignUpData?.user?.OrganizationId);

          if (this.xeroSignUpData?.user?.OrganizationId) {
            sessionStorage.organizationId = this.xeroSignUpData?.user?.OrganizationId;
            sessionStorage.selectedOrganization = this.xeroSignUpData?.user?.OrganizationId;
            this.AddandUpdatesupplierXeroData(this.xeroSignUpData?.user?.OrganizationId, this.xeroSignUpData?.user?.Email)
            this._notificationsHubService.start();
          }
          else {
            this._notificationsHubService.start();
          }
        } else if (error && error != '') {
          this.isSpinnerShown = false;
          this.redirectionText = error;
          this.redirectionSubText = 'Please try again later';

          setTimeout(() => {
            this.redirectionText = null;
            this.redirectionSubText = 'Redirecting...';
            this.isSpinnerShown = true;
          }, 4000);

          setTimeout(() => {
            this.router.navigateByUrl('/signup/step-one');
          }, 5000);
        } else {
          window.location.replace(this.configService.xeroOAuth2SignUpLink);
        }
      });
  }
  private initializeMixpanel() {
    try {
      mixpanel.init('e707a7324df89e08608baa06f42aa847', {
        debug: false,
        track_pageview: true,
        persistence: 'localStorage',
        autocapture: true,                // ✅ required feature
        record_sessions_percent: 100,     // can lower later if needed
      });
    } catch (err) {
      console.error('❌ Mixpanel initialization error:', err);
    }
  }

  private AddandUpdatesupplierXeroData(orgId, email) {
    this.suppliersService.AddandUpdatesupplierXeroDataInitial(orgId, email, RefreshLog_Type.Signup)
      .pipe(take(1))
      .subscribe(data => {
        this.router.navigateByUrl('/dashboard?OrganisationId=' + orgId + "&Domain=Xero");
      });
  }

  setonBoardingStatus(orgId) {
    this.suppliersService.UpdateSigupStep(orgId, 4)
      .pipe(take(1))
      .subscribe(() => {
        this.router.navigateByUrl('/dashboard?OrganisationId=' + orgId + "&Domain=Xero");
      });
  }

  private async initializeAndIdentifyMixpanelUser() {
    try {
      // ✅ SSR-safe: only runs in browser
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }

      // ✅ Step 1: ensure mixpanel library is loaded
      if (typeof (window as any).mixpanel === 'undefined') {
        await new Promise<void>((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
          script.async = true;
          script.onload = async () => {

            // ⏳ Wait up to 2 seconds for window.mixpanel to become available
            const start = Date.now();
            while (typeof (window as any).mixpanel === 'undefined' && Date.now() - start < 2000) {
              await new Promise(r => setTimeout(r, 50));
            }

            const mp = (window as any).mixpanel;
            if (mp) {
              mp.init('e707a7324df89e08608baa06f42aa847', {
                debug: false,
                track_pageview: true,
                persistence: 'localStorage',
                autocapture: true,
                record_sessions_percent: 100,
              });
              resolve();
            } else {
              reject('❌ Mixpanel global not found after load delay');
            }
          };
          script.onerror = (err) => reject(err);
          document.head.appendChild(script);
        });
      } else {
      }

      // ✅ Step 2: identify user safely
      const mp = (window as any).mixpanel;
      const user = this.xeroSignUpData?.user;

      if (!mp || !user?.Id) {
        console.warn('⚠️ Mixpanel not ready or missing user info');
        return;
      }

      mp.identify(user.Id);
      mp.people.set({
        '$name': user.Name,
        '$email': user.Email,
        'plan': 'Premium'
      });
      mp.track('Signup');
    } catch (err) {
      console.error('❌ Mixpanel initialization error:', err);
    }
  }
}
